import React, { useState } from "react";
import Layout from 'Layout'
import Referrals from "./ReferralsAF";
import Payout from "./PayoutAF";
import Dashboard from "./DashboardAF";
import AffiliateHtml from "./AffiliateHtml";
import "./styles.scss"; // <-- import lại toàn bộ SCSS bạn đã viết

const AffiliatePage: React.FC = () => {
    const [activeTab, setActiveTab] = useState("Referrals");

    const tabs = [
        { code: "Referrals", name: "Referrals" },
        { code: "Payout", name: "Payout" },
        // { code: "Dashboard", name: "Bảng điều khiển" },
    ];

    const [activeComponent, setActiveComponent] = useState<1 | 2>(1);

    return (
        <Layout>
            <div className="affiliate-page fz-16">
                {activeComponent === 1 && <AffiliateHtml onNext={() => setActiveComponent(2)} />}
                {/* Tabs */}
                {activeComponent === 2 && (
                    <>
                        <div className="tabs">
                            {tabs.map((tab, index) => (
                                <div
                                    key={index}
                                    className={`tab-item ${tab.code === activeTab ? "active" : ""}`}
                                    onClick={() => setActiveTab(tab.code)}
                                >
                                    {tab.name}
                                </div>
                            ))}
                        </div>
                        {activeTab === "Referrals" && <Referrals />}
                        {activeTab === "Payout" && <Payout />}
                        {activeTab === "Dashboard" && <Dashboard />}
                    </>
                )}
            </div>
        </Layout>
    );
};

export default AffiliatePage;
